"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericUrls = void 0;
exports.genericUrls = {
    attensi: function () { return 'https://attensi.com'; },
    legal: function () { return 'https://legal.attensi.com'; },
    legalDefaultPrivacyPolicy: function () { return 'https://legal.attensi.com/privacy-policy-default.html'; },
    legalEula: function () { return 'https://legal.attensi.com/eula.html'; },
};
//# sourceMappingURL=genericUrls.js.map